<template>
	<div id="home-component" style="height: 900px; display: flex;  flex-direction: column;">
		<reveal-effect v-if="!showContent" name="reveal-effect" style="z-index: 99;" />
		<div v-else>

			<div class=" " style="display: flex; align-self: center; height: 100vh;">
				<point-cloud class="point-cloud-home" />
				<div class="hero-body" style="height: 600px; display: flex;">
					<div class="container" style="display: flex; flex-direction: column; align-self: center;">
						<h1 id="my-name" class="title is-1" style="color: #64c9e0; margin: 0 0 8rem 0" ref="myName">
							{{ translate('greeting') }} Adriel.
						</h1>
					</div>
				</div>
			</div>
			<div id="carousel-container" style="margin: 0px 0 0 0">
				<div id="animated-header">
					<div id="magic"></div>
					<div class="playground">
						<div class="bottomPosition">
							<span style="display: flex; justify-content: center;">
								<svg class="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 278.8 278.8">
									<circle fill="#000205" cx="139.4" cy="139.4" r="139.4" />
									<g fill="none" stroke="#FFF" stroke-width="6.062" stroke-miterlimit="10">
										<path
											d="M214 183.4l-74.6 43.1-75.5-43.6V95.8l75.5-43.5 75.4 43.5v59.8l-11.3 6.5z" />
										<path
											d="M139.4 226.5l-18.8-38.2 18.8 10.8 75.4-43.5M63.9 95.8l75.3 43.6 75.6-43.6M139.2 139.4v59.7" />
									</g>
								</svg>
							</span>
							<h1 style="display: flex; flex-direction: column; align-items: center;">
								ADRIEL WERLICH
								<br>
								<span class="minText">
									Creative developer && software engineer.
								</span>
							</h1>
						</div>
					</div>
				</div>

				<div style="height: 600px;">
					<carousel-3d v-if="slidesPt && slidesPt.length > 0  && language === 'pt'" :autoplay="true"
						:autoplay-timeout="3000" :controls-visible="true" :display="7" :controls-prev-html="'&#x2039; '"
						:controls-next-html="'&#x203A;'" :controls-width="10" :controls-height="30" :clickable="false"
						:height="480" :count="slidesPt.length">

						<slide v-for="(slide, i) in slidesPt" :index="i" :key="i">
							<p>{{i+1}}</p>
							<img :src="slide.image" style="max-height: 250px;">
							<div class="content">
								<p style="min-height: 100px;">{{slide.snippet}}</p>
								<a :href="slide.link" target="__blank" class="button is-fullwidth">
									{{ translate('view-project') }}
								</a>
							</div>
						</slide>
					</carousel-3d>
					<carousel-3d v-if="slidesEn && slidesEn.length > 0 && language === 'en'" :autoplay="true"
						:autoplay-timeout="3000" :controls-visible="true" :display="7" :controls-prev-html="'&#x2039; '"
						:controls-next-html="'&#x203A;'" :controls-width="10" :controls-height="30" :clickable="false"
						:height="480" :count="slidesEn.length">

						<slide v-for="(slide, i) in slidesEn" :index="i" :key="i">
							<p>{{i+1}}</p>
							<img :src="slide.image" style="max-height: 250px;">
							<div class="content">
								<p style="min-height: 100px;">{{slide.snippet}}</p>
								<a :href="slide.link" target="__blank" class="button is-fullwidth">
									{{ translate('view-project') }}
								</a>
							</div>
						</slide>
					</carousel-3d>

					<div id="quotes" style="margin: 10%">
						<h2 id="sub-title-1" class="subtitle is-3" ref="intro" style=""> {{ randomQuote }} </h2>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { Carousel3d, Slide } from 'vue-carousel-3d'
import ProjectsService from '@/services/ProjectsService'
import RevealEffect from '@/components/RevealEffect'
import PointCloud from '../components/PointCloud.vue'
import * as THREE from "three"
import Environment from '../assets/js/FontLoader/Environment'

import {
	TextureEffect,
	BlendFunction,
	BloomEffect,
	KernelSize,
	EffectPass,
	EffectComposer,
	RenderPass
} from "postprocessing";
// import * as POSTPROCESSING from "postprocessing";

export default {
	name: "home",
	components: {
		'carousel-3d': Carousel3d,
		'slide': Slide,
		'reveal-effect': RevealEffect,
		'point-cloud': PointCloud

	},
	destroyed() {
		document.querySelectorAll('.pc').forEach(el => el.remove())

		clearInterval(this.quoteInterval)
		clearInterval(this.colorTransition)

	},
	mounted() {

		this.message = this.language === 'pt' ? 'Meus Projetos' : 'My Projects',

		setTimeout(() => {
			this.showContent = true
		}, 2500)

		setTimeout(() => {
			this.preloadFont()
		}, 2550);

		if (!this.isMobile) {
			this.increaseNameAnimation()
			this.transitionColor()
		}
		this.genRandomQuote()
	},
	watch: {
		language(newValue, oldValue) {
			console.log('watch language', newValue)
			if (newValue === 'pt') {
				this.environment.changeText('Meus projetos')
			} else {
				this.environment.changeText('My projects')
			}
		}
	},
	computed: {
		slidesEn() {
			if (this.projectsEn && this.projectsEn.length > 0) {
				return this.projectsEn
			}
			return null
		},
		slidesPt() {
			if (this.projectsPt && this.projectsPt.length > 0) {
				return this.projectsPt
			}
			return null
		}
	},
	data() {
		return {
			showContent: false,
			environment: null,
			language: 'pt',
			message: '',
			projectsPt: [],
			projectsEn: [],
			appEl: null,
			randomQuote: null,
			isMobile:
				/Android|webOS|iPhone|iPad|Mac|Macintosh|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				),
			randomQuoteIndex: 0,

		}
	},
	created() {

		const self = this
		ProjectsService.getProjects()
			.then(projects => {
				for (var i = 0; i < projects.length; i++) {
					let project = {
						title: projects[i].fields.Title,
						date: projects[i].fields["Date Published"],
						snippet: projects[i].fields.Excerpt,
						image: projects[i].fields.Image[0].url,
						slug: projects[i].fields.slug,
						language: projects[i].fields.language,
						link: projects[i].fields.link,
						body: projects[i].fields.Body
					}
					if (project.language === 'pt') {
						self.projectsPt.push(project)
					} else {
						self.projectsEn.push(project)
					}
				}
			})
			.catch(err => {
				console.log(err)
			})

		this.$parent.$on('changeLang', this.setLang)
	},
	methods: {
		async preloadFont() {


			let manager = new THREE.LoadingManager();
			manager.onLoad = () => {
				this.environment = new Environment(typo, particle, this.message);
			}

			var typo = null;
			const loader = new THREE.FontLoader(manager);
			loader.load('./font_zsd4dr.json', function (font) {
				;
				typo = font;
			});

			const particle = new THREE.TextureLoader(manager).load('./particle_a64uzf.png');
		},
		getQuotes() {
			const quotesEn = [
				'Residing in a small village devoid of proper living facilities, serving a person born of a low family, unwholesome food, a frowning wife, a foolish son, and a widowed daughter burn the body without fire.',

				'What good is a cow that neither gives milk nor conceives? Similarly, what is the value of the birth of a son if he becomes neither learned nor a pure devotee of the Lord?',

				'When one is consumed by the sorrows of life, three things give him relief: offspring, a wife, and the company of the Lord\'s devotees.',

				'Kings speak for once, men of learning once, and the daughter is given in marriage once. All these things happen once and only once.',

				'Religious austerities should be practiced alone, study by two, and singing by three. A journey should be undertaken by four, agriculture by five, and war by many together.',

				'She is a true wife who is clean (suci), expert, chaste, pleasing to the husband, and truthful.',

				'The house of a childless person is a void, all directions are void to one who has no relatives, the heart of a fool is also void, but to a poverty-stricken man all is void.',

				'Scriptural lessons not put into practice are poison; a meal is poison to him who suffers from indigestion; a social gathering is poison to a poverty-stricken person; and a young wife is poison to an aged man.',

				'That man who is without religion and mercy should be rejected. A guru without spiritual knowledge should be rejected. The wife with an offensive face should be given up, and so should relatives who are without affection.',

				'Constant travel brings old age upon a man; a horse becomes old by being constantly tied up; lack of sexual contact with her husband brings old age upon a woman; and garments become old through being left in the sun.',

				'Consider again and again the following: the right time, the right friends, the right place, the right means of income, the right ways of spending, and from whom you derive your power.',

				'For the twice born the fire (Agni) is a representative of God. The Supreme Lord resides in the heart of His devotees. Those of average intelligence (alpa-buddhi or kanista-adhikari) see God only in His sri-murti, but those of broad vision see the Supreme Lord everywhere.',

				'Agni is the worship-able person for the twice born; the brahmana for the other castes; the husband for the wife; and the guest who comes for food at the midday meal for all.',

				'As gold is tested in four ways by rubbing, cutting, heating and beating -- so a man should be tested by these four things: his renunciation, his conduct, his qualities and his actions.',

				'A thing may be dreaded as long as it has not overtaken you, but once it has come upon you, try to get rid of it without hesitation.',

				'Though persons be born from the same womb and under the same stars, they do not become alike in disposition as the thousand fruits of the badari tree.',

				'He whose hands are clean does not like to hold an office; he who desires nothing cares not for bodily decorations; he who is only partially educated cannot speak agreeably; and he who speaks out plainly cannot be a deceiver.',

				'The learned are envied by the foolish; rich men by the poor; chaste women by adulteresses; and beautiful ladies by ugly ones',

				'Indolent application ruins study; money is lost when entrusted to others; a farmer who sows his seed sparsely is ruined; and an army is lost for want of a commander.',

				'Learning is retained through putting into practice; family prestige is maintained through good behavior; a respectable person is recognized by his excellent qualities; and anger is seen in the eyes.',

				'Religion is preserved by wealth; knowledge by diligent practice; a king by conciliatory words; and a home by a dutiful housewife.',

				'Those who blaspheme Vedic wisdom, who ridicule the life style recommended in the satras, and who deride men of peaceful temperament, come to grief unnecessarily.',

				'Charity puts and end to poverty; righteous conduct to misery; discretion to ignorance; and scrutiny to fear.',

				'There is no disease (so destructive) as lust; no enemy like infatuation; no fire like wrath; and no happiness like spiritual knowledge.',

				'A man is born alone and dies alone; and he experiences the good and bad consequences of his karma alone; and he goes alone to hell or the Supreme abode.',

				'Learning is a friend on the journey; a wife in the house; medicine in sickness; and religious merit is the only friend after death.',

				'Rain which falls upon the sea is useless; so is food for one who is satiated; in vain is a gift for one who is wealthy; and a burning lamp during the daytime is useless.',

				'There is no water like rainwater; no strength like one\'s own; no light like that of the eyes; and no wealth more dear than food grain.',

				'The poor wish for wealth; animals for the faculty of speech; men wish for heaven; and godly persons for liberation.',

				'The earth is supported by the power of truth; it is the power of truth that makes the sunshine and the winds blow; indeed all things rest upon truth.',
			]
			const quotesPt = [
				'Residir em um pequeno vilarejo desprovido de instalações adequadas para morar, servindo a uma pessoa nascida de uma família baixa, comida insalubre, uma esposa carrancuda, um filho tolo e uma filha viúva, queima o corpo sem fogo.',

				'Para que serve uma vaca que não dá leite nem concebe? Da mesma forma, qual é o valor do nascimento de um filho se ele não se torna nem culto nem devoto puro do Senhor? ',

				'Quando alguém é consumido pelas tristezas da vida, três coisas o aliviam: descendência, uma esposa e a companhia dos devotos do Senhor.',

				'Os reis falam pelo menos uma vez, os homens eruditos uma vez, e a filha é dada em casamento uma vez. Todas essas coisas acontecem uma vez e apenas uma vez. ',

				'As austeridades religiosas deveriam ser praticadas sozinho, estudar a dois e cantar a três. Uma jornada deve ser empreendida por quatro, a agricultura por cinco e a guerra por muitos juntos. ',

				'Ela é uma esposa verdadeira que é limpa (suci), experiente, casta, agradável ao marido e verdadeira.',

				'A casa de uma pessoa sem filhos é vazia, todas as direções são vazias para quem não tem parentes, o coração de um tolo também está vazio, mas para um homem pobre tudo é vazio.',

				'As lições das escrituras não postas em prática são venenos; uma refeição é veneno para quem sofre de indigestão; uma reunião social é um veneno para uma pessoa pobre; e uma jovem esposa é um veneno para um homem idoso. ',

				'Aquele homem que não tem religião e misericórdia deve ser rejeitado. Um guru sem conhecimento espiritual deve ser rejeitado. A esposa com cara de ofensiva deve ser abandonada, assim como os parentes que não têm afeto. ',

				'As viagens constantes trazem a velhice para o homem; um cavalo envelhece por ser constantemente amarrado; a falta de contato sexual com o marido acarreta a velhice da mulher; e as roupas envelhecem por serem deixadas ao sol. ',

				'Considere repetidamente o seguinte: a hora certa, os amigos certos, o lugar certo, os meios certos de renda, as formas certas de gastar e de quem você obtém o seu poder.',

				'Para os nascidos duas vezes, o fogo (Agni) é um representante de Deus. O Senhor Supremo reside no coração de Seus devotos. Aqueles de inteligência média (alpa-buddhi ou kanista-adhikari) veem Deus apenas em Sua sri-murti, mas aqueles de visão ampla veem o Senhor Supremo em todos os lugares. ',

				'Agni é a pessoa capaz de adoração para os nascidos duas vezes; o brahmana para as outras castas; o marido pela esposa; e o convidado que vem buscar comida na refeição do meio-dia para todos. ',

				'Como o ouro é testado de quatro maneiras, esfregando, cortando, aquecendo e batendo - então um homem deve ser testado por estas quatro coisas: sua renúncia, sua conduta, suas qualidades e suas ações.',

				'Uma coisa pode ser temida, contanto que não tenha alcançado você, mas uma vez que vier sobre você, tente se livrar dela sem hesitação.',

				'Embora as pessoas nasçam do mesmo útero e sob as mesmas estrelas, elas não se parecem na disposição dos mil frutos da árvore badari.',

				'Aquele cujas mãos estão limpas não gosta de ocupar um cargo; aquele que nada deseja, não se preocupa com as decorações corporais; aquele que é apenas parcialmente educado não pode falar agradavelmente; e aquele que fala abertamente não pode ser um enganador. ',

				'Os eruditos são invejados pelos tolos; homens ricos pelos pobres; mulheres castas por adúlteras; e lindas damas por feias ',

				'Estudo de ruínas de aplicações indolentes; dinheiro é perdido quando confiado a outros; um fazendeiro que semeia sua semente esparsamente está arruinado; e um exército está perdido por falta de um comandante. ',

				'A aprendizagem é retida colocando em prática; o prestígio da família é mantido por meio do bom comportamento; uma pessoa respeitável é reconhecida por suas excelentes qualidades; e a raiva é vista nos olhos. ',

				'A religião é preservada pela riqueza; conhecimento pela prática diligente; um rei por palavras conciliatórias; e uma casa de uma dona de casa obediente. ',

				'Aqueles que blasfemam a sabedoria Védica, que ridicularizam o estilo de vida recomendado nos satras, e que ridicularizam os homens de temperamento pacífico, sofrem desnecessariamente.',

				'A caridade acaba com a pobreza; conduta justa para com a miséria; discrição à ignorância; e escrutínio ao medo. ',

				'Não há doença (tão destrutiva) como a luxúria; nenhum inimigo como a paixão; nenhum fogo como a ira; e nenhuma felicidade como o conhecimento espiritual. ',

				'Um homem nasce sozinho e morre sozinho; e ele experimenta as consequências boas e más de seu karma sozinho; e ele vai sozinho para o inferno ou a morada Suprema. ',

				'Aprender é um amigo na jornada; uma esposa na casa; remédio na doença; e o mérito religioso é o único amigo após a morte. ',

				'A chuva que cai sobre o mar é inútil; assim é a comida para quem está saciado; em vão é um presente para quem é rico; e uma lâmpada acesa durante o dia é inútil. ',

				'Não há água como a água da chuva; nenhuma força como a própria; nenhuma luz como a dos olhos; e nenhuma riqueza mais cara do que grãos alimentícios. ',

				'Os pobres desejam riqueza; animais para a faculdade da fala; os homens desejam o céu; e pessoas piedosas para a libertação. ',

				'A terra é sustentada pelo poder da verdade; é a força da verdade que faz soprar o sol e os ventos; na verdade, todas as coisas dependem da verdade. ',

			]
			return { quotesEn, quotesPt }
		},
		genRandomQuote() {

			const quotes = this.getQuotes()
			this.randomLogic(quotes)
			this.quoteInterval = setInterval(() => {
				this.randomLogic(quotes)
			}, 10000);
		},
		randomLogic(quotes) {
			if (this.language == 'pt') {
				this.randomQuote = quotes.quotesPt[this.randomQuoteIndex]
			} else {
				this.randomQuote = quotes.quotesEn[this.randomQuoteIndex]
			}
			this.randomQuoteIndex++
			if (this.randomQuoteIndex == quotes.quotesEn.length) this.randomQuoteIndex = 0
		},
		transitionColor() {

			const values = [
				'rgba(9, 5, 254, 0.984)',
				'rgba(254, 22, 5, 0.986)',
				'rgba(254, 217, 5, 0.986)',
				'rgba(254, 250, 5, 0.986)',
				'rgba(217, 254, 5, 0.986)',
				'rgba(84, 254, 5, 0.986)',
				'rgba(5, 254, 179, 0.986)',
				'rgba(5, 254, 242, 0.986)',
				'rgba(5, 175, 254, 0.986)',
				'rgba(183, 5, 254, 0.986)'
			]

			let index = 1, ls = this

			this.colorTransition = setInterval(() => {

				if (ls.$refs.myName && ls.$refs.myName.style) {

					ls.$refs.myName.style.textShadow =
						`rgb(255, 255, 255) 0px 0px 7.6px, ${values[index]} 0px 0px 30.4px, rgb(254, 5, 225) 0px 0px 45.6px`

					index++

					if (index == 9) index = 0

				}

			}, 2000);

		},
		increaseNameAnimation() {
			let d = -6
			const increaseInterval = setInterval(() => {
				if (this.$refs.myName && this.$refs.myName.style) {
					this.$refs.myName.style.transform = `rotate(${d}deg)`
					d += .1
					if (d >= 7) {
						clearInterval(increaseInterval)
						this.decreaseNameAnimation(d)
					}
				}
			}, 50);



		},
		decreaseNameAnimation(d) {
			const decreaseInterval = setInterval(() => {
				if (this.$refs.myName && this.$refs.myName.style) {
					this.$refs.myName.style.transform = `rotate(${d}deg)`
					d -= .1
					if (d <= -6) {
						clearInterval(decreaseInterval)
						this.increaseNameAnimation()
					}
				}
			}, 50);
		},
		setLang(lang) {
			this.language = lang //= 'en' ? this.language = 'pt' : this.language = 'en'
			console.log('set lang', this.language)
		},
		translate(section) {
			switch (section) {
				case 'view-project':
					if (this.language === 'pt') {
						return 'Ver projeto'
					} else {
						return 'View Project'
					}
				case 'greeting':
					if (this.language == 'en') {
						return 'Hello, I\'m'
					} else if (this.language == 'pt') {
						return 'Olá, me chamo'
					}
				case 'intro':
					if (this.language == 'en') {
						return 'Wise men should never go into a country where there are no means of earning one\'s livelihood, where the people have no dread of anybody, have no sense of shame, no intelligence, or a charitable disposition'//'A solution delivery focused, technically minded web developer'
					} else if (this.language == 'pt') {
						return 'Homens sábios nunca devem ir para um país onde não haja meios de ganhar a vida, onde as pessoas não tenham medo de ninguém, não tenham senso de vergonha, inteligência ou disposição caridosa' //'Um desenvolvedor web com mindset inovador focado em entregar soluções'
					}

			}
		},
		cloudParticles() {
			let scene, camera, cloudParticles = [], composer;
			scene = new THREE.Scene();
			camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 1, 1000);
			camera.position.z = 1;
			camera.rotation.x = 1.16;
			camera.rotation.y = -0.12;
			camera.rotation.z = 0.27;

			let ambient = new THREE.AmbientLight(0x555555);
			scene.add(ambient);

			let directionalLight = new THREE.DirectionalLight(0xff8c19);
			directionalLight.position.set(0, 0, 1);
			scene.add(directionalLight);

			let orangeLight = new THREE.PointLight(0xcc6600, 50, 450, 1.7);
			orangeLight.position.set(200, 300, 100);
			scene.add(orangeLight);
			let redLight = new THREE.PointLight(0xd8547e, 50, 450, 1.7);
			redLight.position.set(100, 300, 100);
			scene.add(redLight);
			let blueLight = new THREE.PointLight(0x3677ac, 50, 450, 1.7);
			blueLight.position.set(300, 300, 200);
			scene.add(blueLight);

			const renderer = new THREE.WebGLRenderer({ canvas: document.getElementById('home-bg') });
			renderer.setSize(window.innerWidth, 800);
			scene.fog = new THREE.FogExp2(0x03544e, 0.001);
			renderer.setClearColor(scene.fog.color);
			document.body.appendChild(renderer.domElement);

			let loader = new THREE.TextureLoader();
			loader.load("smoke.png", function (texture) {
				const cloudGeo = new THREE.PlaneBufferGeometry(500, 500);
				const cloudMaterial = new THREE.MeshLambertMaterial({
					map: texture,
					transparent: true
				});

				for (let p = 0; p < 50; p++) {
					let cloud = new THREE.Mesh(cloudGeo, cloudMaterial);
					cloud.position.set(
						Math.random() * 800 - 400,
						500,
						Math.random() * 500 - 500
					);
					cloud.rotation.x = 1.16;
					cloud.rotation.y = -0.12;
					cloud.rotation.z = Math.random() * 2 * Math.PI;
					cloud.material.opacity = 0.55;
					cloudParticles.push(cloud);
					scene.add(cloud);
				}
			});
			loader.load("stars.jpg", function (texture) {
				const textureEffect = new TextureEffect({
					blendFunction: BlendFunction.COLOR_DODGE,
					texture: texture
				});
				textureEffect.blendMode.opacity.value = 0.2;

				const bloomEffect = new BloomEffect({
					blendFunction: BlendFunction.COLOR_DODGE,
					kernelSize: KernelSize.SMALL,
					useLuminanceFilter: true,
					luminanceThreshold: 0.3,
					luminanceSmoothing: 0.75
				});
				bloomEffect.blendMode.opacity.value = 1.5;

				let effectPass = new EffectPass(
					camera,
					bloomEffect,
					textureEffect
				);
				effectPass.renderToScreen = true;

				composer = new EffectComposer(renderer);
				composer.addPass(new RenderPass(scene, camera));
				composer.addPass(effectPass);

				window.addEventListener("resize", onWindowResize, false);
				function onWindowResize() {
					// camera.aspect = window.innerWidth / window.innerHeight;
					// camera.updateProjectionMatrix();
					// renderer.setSize(window.innerWidth, window.innerHeight);
				}
				function render() {
					cloudParticles.forEach(p => {
						p.rotation.z -= 0.001;
					});
					composer.render(0.1);
					requestAnimationFrame(render);
				}
				render();
			});

		}
	},
};
</script>

<style>
.carousel-3d-slider {
	width: 500px !important;
	height: 500px !important;
}

.carousel-3d-slide {
	width: 500px !important;
	height: 500px !important;
}

#magic {
	margin: 0 auto;
	width: 100vw;
	height: 450px;
	display: block;
	top: 0;
	left: 0;
	z-index: -9999;
}

.playground {
	/* position: fixed; */
	width: 100%;
	height: 100px;
	display: block;
	top: 0;
	left: 0;
	display: flex;
	flex-wrap: nowrap;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
}

.bottomPosition {
	text-align: center;
	margin-bottom: 50px;

}

.minText {
	font-size: 14px;
}

#animated-header {
	display: flex;
	flex-direction: column;
	justify-content: center;
}

.logo {
	width: 50px;
	height: 50px;
}

#carousel-container {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 720px;
}

.carousel-3d-slide {
	padding: 3%;
	opacity: 1;
	visibility: visible;
}

.hero-home {
	/* height: 1400px; */
	background: unset;
	z-index: 1;
}

.carousel-3d-container {
	position: sticky !important;
	top: 40%;
	/* width: 85%; */
}

#my-name {
	font-family: 'Mr-Dafoe';
	margin: 0;
	font-size: 9.5em;
	margin-top: -0.6em;
	color: white;
	text-shadow: 0 0 0.05em #fff, 0 0 0.2em #fe05e1fb, 0 0 0.3em #fe05e1;
	transform: rotate(-7deg);
	transition: text-shadow 1s ease-out;
	-webkit-transition: text-shadow 1s ease-out;
	-moz-transition: text-shadow 1s ease-out;
	-o-transition: text-shadow 1s ease-out;
}

@media only screen and (max-width: 700px) {
	#my-name {
		font-size: 4.5em;
		transform: rotate(1deg);
	}
}

#sub-title-1 {
	color: #0043ff;
	min-height: 130px;
	/* white; */
	/* animation: neon 3s infinite; */
}

/* @keyframes changeColor { */
/* 0% {
			transform: text-shadow: 0, 0);
		}

		25% {
			transform: text-shadow: 200px, 0);
		}

		50% {
			transform: text-shadow: 200px, 200px);
		}

		75% {
			transform: text-shadow: 0, 200px);
		} */
/* } */

@keyframes neon {
	0% {
		text-shadow: -1px -1px 1px var(--shadow-color-light), -1px 1px 1px var(--shadow-color-light), 1px -1px 1px var(--shadow-color-light), 1px 1px 1px var(--shadow-color-light),
			0 0 3px var(--shadow-color-light), 0 0 10px var(--shadow-color-light), 0 0 20px var(--shadow-color-light),
			0 0 30px var(--shadow-color), 0 0 40px var(--shadow-color), 0 0 50px var(--shadow-color), 0 0 70px var(--shadow-color), 0 0 100px var(--shadow-color), 0 0 200px var(--shadow-color);
	}

	50% {
		text-shadow: -1px -1px 1px var(--shadow-color-light), -1px 1px 1px var(--shadow-color-light), 1px -1px 1px var(--shadow-color-light), 1px 1px 1px var(--shadow-color-light),
			0 0 5px var(--shadow-color-light), 0 0 15px var(--shadow-color-light), 0 0 25px var(--shadow-color-light),
			0 0 40px var(--shadow-color), 0 0 50px var(--shadow-color), 0 0 60px var(--shadow-color), 0 0 80px var(--shadow-color), 0 0 110px var(--shadow-color), 0 0 210px var(--shadow-color);
	}

	100% {
		text-shadow: -1px -1px 1px var(--shadow-color-light), -1px 1px 1px var(--shadow-color-light), 1px -1px 1px var(--shadow-color-light), 1px 1px 1px var(--shadow-color-light),
			0 0 3px var(--shadow-color-light), 0 0 10px var(--shadow-color-light), 0 0 20px var(--shadow-color-light),
			0 0 30px var(--shadow-color), 0 0 40px var(--shadow-color), 0 0 50px var(--shadow-color), 0 0 70px var(--shadow-color), 0 0 100px var(--shadow-color), 0 0 200px var(--shadow-color);
	}
}
</style>